import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
import { Link } from "react-router-dom";

function TowerRushJackpotPromo(props: any) {
    const { theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            <InformationWrapper>
                <ImageWrapper className="GTRCard">
                    <Link to="/instant-games/galaxsys/tower-rush">
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.GTRInnerCard}`}
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </Link>
                </ImageWrapper>
                <PrizeWrapper>
                    <Prize>
                        <h3>₹10 Lakh</h3>
                        <p>Total promotion prize pool</p>
                    </Prize>
                    <Seperater />
                    <Prize>
                        <h3>₹1 Lakh</h3>
                        <p>Daily jackpot prize</p>
                    </Prize>
                    <Seperater />
                    <Prize>
                        <h3>1 Winner</h3>
                        <p>Selected every day</p>
                    </Prize>
                </PrizeWrapper>
                <h1>This Diwali, Win a Share of the ₹10 Lakh Jackpot!</h1>

                <h2>How to Claim</h2>
                <ImageWrapper>
                    <LazyLoadImage
                        src={`${config.imageV3Host}/static/cashsite/${theme.image.GTRSteps}`}
                        effect="none"
                        placeholder={<PlaceholderImage />}
                    />
                </ImageWrapper>

                <h2>Terms & Conditions</h2>
                <TermsList>
                    <li>The promotion runs from <strong>6th November to 16th November.</strong></li>
                    <li>Each qualifying bet of <strong>₹1,000</strong> on Tower Rush earns one entry into the daily jackpot draw.</li>
                    <li>Multiple qualifying bets can earn multiple entries during the promotion period.</li>
                    <li><strong>One winner</strong> will be selected each day and awarded <strong>₹1 Lakh.</strong></li>
                    <li>The total jackpot prize pool for the promotion is <strong>₹10 Lakh.</strong></li>
                    <li>Only valid bets placed on Tower Rush during the promotion period will qualify.</li>
                    <li>The promotion is subject to the applicable terms and conditions.</li>
                </TermsList>
            </InformationWrapper>
        </>
    );
}

export default withTheme(withAppContext(TowerRushJackpotPromo));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.GTRInnerBG")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    position: relative;
    gap: 2rem;

    h1, h2, p {
        margin: 0;
        padding: 0;
    }

    h1, h2 {
        width: 100%;
        color: #FDE102;
        text-align: center;
        font-style: normal;
        font-weight: 700;
        font-family: 'Inter-Bold';
        line-height: normal;
    }

    h1 {
        font-size: 22px;
        text-transform: capitalize;
        color: #FFF;
    }

    h2 {
        font-size: 20px;
        text-transform: capitalize;
    }

    .top-para {
        width: 100%;
        color: #FFF;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 35px;
        text-transform: none;
    }

    .GTRCard {
        & span {
            display: flex !important;
            justify-content: center !important;

            img {
                width: 50%;
            } 
        }
    }
`;


const ImageWrapper = styled.div`
    width: 65%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(7px);
    
    img {
        width: 100%;
    }
`;

const TermsList = styled.ul`
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
    margin: 0 auto;
    padding: 0;
    list-style: none;

    li {
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        text-align: left;
        font-weight: 400;
        line-height: 27px;
        text-transform: capitalize;
        background: #707070;
        padding: 12px 1.5rem 12px 2.5rem;
        position: relative;
    }

    li::before {
        content: "✦";
        position: absolute;
        color: #fff;
        left: 1.5rem;
        top: 12px;
    }
`;

const PrizeWrapper = styled.div`
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 25px 100px;
    border-top: 1px solid #FFF;
    border-bottom: 1px solid #FFF;
    gap: 50px;
    margin-bottom: 10px;
`;

const Prize = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
    padding: 5px;

    h3, p {
        margin: 0;
        padding: 0;
        text-align: left;
        text-transform: none;
        font-style: normal;
        text-transform: capitalize;
    }

    h3 {
        font-size: 25px;
        font-weight: 700;
        line-height: 18.801px;
        color: #FDE102;
    }

    p {
        font-size: 15.313px;
        font-weight: 400;
        line-height: 24px;
        color: #FFF;
    }
`;

const Seperater = styled.div`
    width: 1px;
    flex: 0 0 1px;
    background: #FFF;
    align-self: stretch;
`;